<template>
    <div
        class="padding7 el-card"
        v-loading="openloading"
        :element-loading-text="loadingText"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-form
            :model="voucherQueryModel"
            label-width="120px"
            label-position="left"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item
                            label="品牌"
                            label-width="80px"
                            :required="true"
                        >
                            <el-select
                                v-model="voucherQueryModel.brandId"
                                placeholder="选择品牌"
                                size="mini"
                                class="width100"
                                @change="brandChange"
                                filterable
                            >
                                <el-option
                                    v-for="item in brandList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="业务日期"
                            label-width="80px"
                            :required="true"
                        >
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                range-separator="-"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                align="right"
                                size="mini"
                                style="width: 100%"
                                @change="timeChange"
                                :picker-options="pickerOptions"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="生成方式" label-width="80px">
                            <el-select
                                v-model="voucherQueryModel.groupType"
                                placeholder="选择凭证生成方式"
                                size="mini"
                                class="width100"
                                @change="accountChange"
                            >
                                <el-option
                                    v-for="item in voucherTypeList"
                                    :key="item.number"
                                    :label="item.name"
                                    :value="item.number"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="制单状态" label-width="80px">
                            <el-select
                                v-model="voucherQueryModel.makeOrderState"
                                placeholder="选择制单状态"
                                size="mini"
                                class="width100"
                                filterable
                            >
                                <el-option
                                    v-for="state in makeOrderStateList"
                                    :key="state.id"
                                    :label="state.name"
                                    :value="state.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="top7">
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-left"
                            @click="search(false)"
                            :disabled="!brandSel"
                            >查询</el-button
                        >
                        <el-tooltip
                            class="item"
                            effect="dark"
                            content="数据在第一次拉取后已本地化缓存，若需更新数据，请使用重新拉取操作"
                            placement="top-start"
                        >
                            <el-button
                                type
                                size="mini"
                                class="pull-left"
                                icon="el-icon-download"
                                @click="search(true)"
                                :disabled="!storeSel"
                                >重新拉取</el-button
                            >
                        </el-tooltip>
                        <el-button
                            type
                            size="mini"
                            icon="el-icon-search"
                            class="pull-left right-10"
                            @click="searchmore"
                            :disabled="!brandSel"
                            >高级查询</el-button
                        >
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-download"
                            class="pull-left"
                            @click="openDialog"
                            :disabled="!isSearchVal"
                            >生成凭证</el-button
                        >
                    </el-col>
                </el-row>
            </div>
        </el-form>
        <span style="color: red; font-size: 20px">注:默认全选 无需勾选</span>
        <el-table
            :data="tableData"
            size="mini"
            style="width: 100%"
            border
            ref="tableData"
            :row-key="getRowKeys"
            @selection-change="handleSelectionChange"
            show-summary
            :summary-method="getSummaries"
        >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column
                prop="sysBillCode"
                label="单据号"
            ></el-table-column>
            <el-table-column label="业务日期">
                <template slot-scope="scope">
                    <span
                        :class="scope.row.color"
                        style="margin-right: 10px"
                    ></span>
                    {{ dateFormat(scope.row.workDate) }}
                </template>
            </el-table-column>
            <el-table-column
                prop="billTypeName"
                label="单据类型"
            ></el-table-column>
            <el-table-column
                prop="payableName"
                label="付款方集团"
            ></el-table-column>
            <el-table-column
                prop="paymentName"
                label="收款方"
            ></el-table-column>
            <el-table-column
                prop="paymentAmount"
                label="应付金额"
            ></el-table-column>
        </el-table>
        <pagerBar
            ref="refPagerBar"
            :apiURL="VoucherDataApi"
            :GetData="getTableData"
            :queryParam="queryParam"
            :isInit="false"
            :errorFunc="errorHandler"
        ></pagerBar>
        <targetStore ref="targetStore"></targetStore>
        <el-dialog
            width="70%"
            title="高级查询"
            :visible.sync="searchMoreVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="true"
        >
            <el-tabs v-model="currentSearch" @tab-click="tabpanechange">
                <el-tab-pane
                    v-for="item in searchMoreList"
                    :label="item.label"
                    :name="item.id + ' '"
                >
                    <el-form
                        :model="item"
                        label-width="120px"
                        label-position="left"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="单据号" label-width="70px">
                                    <el-input
                                        v-model="item.billNo"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="业务日期"
                                    label-width="70px"
                                >
                                    <el-date-picker
                                        v-model="item.busDate"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期"
                                        align="right"
                                        size="mini"
                                        style="width: 100%"
                                        :picker-options="pickerOptions"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="付款方" label-width="70px">
                                    <el-input
                                        v-model="item.orgName"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="收款方" label-width="70px">
                                    <el-input
                                        v-model="item.otherSideName"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <el-form-item
                                    label="制单状态"
                                    label-width="68px"
                                >
                                    <el-select
                                        v-model="item.makeOrderState"
                                        placeholder="选择单据状态"
                                        size="mini"
                                        class="width100"
                                        filterable
                                    >
                                        <el-option
                                            v-for="state in makeOrderStateList"
                                            :key="state.id"
                                            :label="state.name"
                                            :value="state.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item
                                    label="方案名称"
                                    label-width="70px"
                                >
                                    <el-input
                                        v-model="item.name"
                                        size="mini"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label-width="0px">
                                    <el-button
                                        icon="el-icon-check"
                                        type="primary"
                                        size="mini"
                                        class
                                        @click="savePlan(item)"
                                        >保存方案</el-button
                                    >
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        size="mini"
                                        @click="delPlan(item.id)"
                                        v-if="item.id != 0"
                                        >删除方案</el-button
                                    >
                                    <el-button
                                        icon="el-icon-search"
                                        type="primary"
                                        size="mini"
                                        @click="searchPlan(item)"
                                        >查询</el-button
                                    >
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import config from '@/common/config.js'
import pagerBar from '@/views/pager/pagerBar'
import AjaxHelper from '@/common/js/AjaxHelper'
import targetStore from '@/views/voucherAdmin/z5storeTransfer'
export default {
    components: {
        targetStore,
        pagerBar
    },
    data() {
        return {
            loadingText: '加载中',
            openloading: false,
            isSearchVal: false,
            isVoucherCreate: false,
            queryParam: {},
            brandSel: false,
            storeSel: false,
            CurrnetMID: 0,
            CloudDataUrl: config.BASE_Middle_API + 'CloudShopInfo',
            VoucherCreateApi: config.BASE_Middle_API + 'VoucherCreate',
            VoucherDataApi:
                config.BASE_Middle_API + 'VoucherCreate/GetZ5SSSFCloudData', //获取源数据接口 需提供
            saveApi:
                config.BASE_Middle_API +
                'VoucherCreate/MutilShopsZ5CloudDataHandle',
            Visible: false,
            optionsList: [],
            moduleList: [],
            brandList: [],
            brands: [],
            storesList: [],
            stores: [],
            ordersList: [],
            tableData: [],
            accountList: [],
            voucherTypeList: [
                { number: '2', name: '按照选择日期生成一张凭证' },
                { number: '1', name: '按照单据编号生成凭证' }
                // { number: "2", name: "按照单据供应商生成凭证" },
            ],
            makeOrderStateList: [],

            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            const end = start
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上周',
                        onClick(picker) {
                            var now = new Date() //当前日期
                            var nowDayOfWeek = now.getDay() //今天本周的第几天
                            var nowDay = now.getDate() //当前日
                            var nowMonth = now.getMonth() //当前月
                            var nowYear = now.getYear() //当前年
                            nowYear += nowYear < 2000 ? 1900 : 0 //
                            var start = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek - 6
                            )
                            const end = new Date(
                                nowYear,
                                nowMonth,
                                nowDay - nowDayOfWeek
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '上月',
                        onClick(picker) {
                            const starttime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .startOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')
                            const endtime = moment(
                                moment()
                                    .month(moment().month() - 1)
                                    .endOf('month')
                                    .valueOf()
                            ).format('YYYY-MM-DD HH:mm:ss')

                            picker.$emit('pick', [starttime, endtime])
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            let start = new Date(
                                moment()
                                    .startOf('month')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            let end = new Date(
                                moment()
                                    .endOf('days')
                                    .format('YYYY-MM-DD HH:mm:ss')
                            )
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            )
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            time: [
                moment().format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],
            voucherQueryModel: {
                startTime: moment().format('YYYY-MM-DD'),
                endTime: moment().format('YYYY-MM-DD'),
                brandId: '',
                store: '',
                orderType: '',
                groupType: '2',
                orderIds: [],
                orderState: 0,
                isSSSF: false,
                makeOrderState: 0
            },
            isMultiOrg: false,
            selOrder: [],
            selOrderIds: [],
            multipeleSelectedIds: [],
            searchMoreVisible: false,
            currentSearch: '0 ',
            moneyTotalInfo: {
                totalApMoney: 0,
                totalApMoneyPager: 0
            },
            searchMoreList: [],
            searchMoreEmpty: {
                label: '高级查询',
                name: '',
                id: '0',
                billNo: '',
                busDate: [],
                otherSideName: '',
                orgName: '',
                orderState: 0,
                makeOrderState: 0
            },
            searchDataTemp: {}
        }
    },
    props: {
        tabType: {
            type: String,
            required: true
        }
    },

    mounted() {
        this.getModules()
        this.makeOrderStateList.push({ id: 0, name: '全部' })
        this.makeOrderStateList.push({ id: 1, name: '未制单' })
    },
    methods: {
        closeloadingHandler() {
            this.openloading = false
        },
        openloadingHandler() {
            this.openloading = true
        },
        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
                /[xy]/g,
                function (c) {
                    var r = (Math.random() * 16) | 0,
                        v = c == 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                }
            )
        },
        getRowKeys(row) {
            return row.sysBillCode
        },
        getSummaries(param) {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计'
                    return
                }
                // if (index === 5) {
                //     sums[index] = "";
                //     return;
                // }
                const values = data.map((item) => Number(item[column.property]))
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr)
                        if (!isNaN(value)) {
                            return prev + curr
                        } else {
                            return prev
                        }
                    }, 0)
                    sums[index] = parseFloat(sums[index]).toFixed(2)
                } else {
                    sums[index] = ''
                }
            })

            return sums
        },
        accountChange(val) {},
        handleSelectionChange(val) {
            const _this = this
            if (_this.selOrder.length == 0) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            } else {
                let b = false
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        b = true
                        item.value = val
                    }
                })
                if (!b) {
                    _this.selOrder.push({
                        key: _this.$refs.refPagerBar.currentPage,
                        value: val
                    })
                }
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.tableData.find(
                            (tableRow) =>
                                tableRow.sysBillCode === row.sysBillCode
                        )
                        this.$refs.tableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.tableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item.sysBillCode === row.sysBillCode)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (
                    !_this.selOrder.find(
                        (item) => item.sysBillCode === key.sysBillCode
                    )
                ) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item.sysBillCode !== row.sysBillCode
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.tableData)
            } else {
                this.removeRows(this.tableData)
            }
        },
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD')
        },
        timeChange(val) {
            this.voucherQueryModel.startTime = moment(val[0]).format(
                'YYYY-MM-DD'
            )
            this.voucherQueryModel.endTime = moment(val[1]).format('YYYY-MM-DD')
        },
        errorHandler() {
            this.closeloadingHandler()
        },
        search(isAgainPull) {
            const _this = this
            _this.openloadingHandler()
            _this.queryTick = _this.guid()
            cf.event.on('app.chat.messageReceived', function (message) {
                if (_this.queryTick === message.sharedMessageId) {
                    _this.loadingText = message.message
                }
            })
            let confirmData = Object.assign(
                { tick: _this.queryTick },
                _this.voucherQueryModel
            )
            if (_this.voucherQueryModel.brandId == '') {
                _this.$message({
                    type: 'error',
                    position: 'bottom-right',
                    message: '请先选择品牌'
                })
                _this.closeloadingHandler()
                return
            }
            confirmData.storeID = 1
            confirmData.storeCode = ''
            if (
                _this.voucherQueryModel.orderType == null ||
                _this.voucherQueryModel.orderType == []
            ) {
                let orderTypeCode = []
                _this.ordersList.map((x) => {
                    orderTypeCode.push(x.billTypeCode)
                })
                confirmData.billTypes = orderTypeCode.join(',')
            } else {
                confirmData.billTypes =
                    _this.voucherQueryModel.orderType.join(',')
            }
            confirmData.isAgainPull = isAgainPull
            confirmData.makeOrderState = _this.voucherQueryModel.makeOrderState
            confirmData.orderState = _this.voucherQueryModel.orderState
            confirmData.groupType = _this.voucherQueryModel.groupType
            _this.queryParam = Object.assign({}, confirmData)
            _this.searchDataTemp = {}
            _this.searchDataTemp = Object.assign({}, confirmData)
        },

        tabpanechange(tab, event) {
            var val = []
            this.searchMoreList.map((x) => {
                if (tab.name == x.id + ' ') {
                    val = x.orgName
                }
            })
        },
        searchmore() {
            this.searchMoreVisible = true
            this.currentSearch = '0 '
            this.searchMoreList = []
            let confirmData = {
                label: '高级查询',
                name: '',
                id: '0',
                billNo: '',
                busDate: [],
                billType: [],
                billBusType: [],
                otherSideName: '',
                otherWarehouseName: '',
                orderState: 0,
                makeOrderState: 0,
                orgName: '',
                brandID: this.voucherQueryModel.brandId
            }
            this.searchMoreEmpty = confirmData
            this.searchMoreList.push(this.searchMoreEmpty)
            this.initSearchPlan()
        },
        //获得查询方案
        initSearchPlan() {
            const _this = this
            _this.$nextTick(function () {
                AjaxHelper.get(
                    _this.VoucherCreateApi +
                        '/GetSearchPlans?brandId=' +
                        _this.voucherQueryModel.brandId,
                    {
                        ModuleMark: 'Z5SSSF'
                    }
                )
                    .then(function (response) {
                        if (response.success) {
                            if (
                                response.result != null &&
                                response.result.length > 0
                            ) {
                                response.result.forEach((item) => {
                                    item.label = item.name
                                    if (item.billTypes) {
                                        item.billType =
                                            item.billTypes.split(',')
                                    }
                                    var busDate = []
                                    if (
                                        item.busDateBegin != null &&
                                        item.busDateEnd != null
                                    ) {
                                        busDate.push(
                                            new moment(
                                                item.busDateBegin
                                            ).format('YYYY-MM-DD')
                                        )
                                        busDate.push(
                                            new moment(item.busDateEnd).format(
                                                'YYYY-MM-DD'
                                            )
                                        )
                                    }
                                    item.busDate = busDate
                                    if (item.orderState == null) {
                                        item.ordersList = 0
                                    }
                                    _this.searchMoreList.push(item)
                                })
                            }
                        }
                    })
                    .catch(function (error) {})
            })
        },
        //删除查询方案
        delPlan(id) {
            const _this = this
            AjaxHelper.post(_this.VoucherCreateApi + '/SearchPlanDelete', {
                id: id
            })
                .then(function (response) {
                    if (response.success) {
                        _this.$notify({
                            title: '成功',
                            message: '删除成功',
                            type: 'success',
                            position: 'bottom-right'
                        })
                        _this.initSearchPlan()
                        _this.currentSearch = '0 '
                    }
                })
                .catch(function (error) {
                    _this.$notify({
                        title: '提示',
                        message: error.message,
                        type: 'error',
                        position: 'bottom-right'
                    })
                })
        },
        //高级查询
        searchPlan(item) {
            const _this = this
            var b = _this.checkSearchPlan(item)
            if (b) {
                _this.searchMoreVisible = false
                _this.openloadingHandler()
                if (_this.voucherQueryModel.brandId == '') {
                    _this.$message({
                        type: 'error',
                        position: 'bottom-right',
                        message: '请先选择品牌'
                    })
                    _this.closeloadingHandler()
                    return
                }
                let confirmData = Object.assign({}, _this.voucherQueryModel)
                confirmData.storeID = 1
                confirmData.storeCode = ''
                confirmData.billNo = item.billNo
                confirmData.otherSideName = item.otherSideName
                confirmData.orgName = item.orgName
                //处理日期
                if (item.busDate != [] && item.busDate.length == 2) {
                    //高级查询处理了日期，则页面查询同步
                    _this.time = item.busDate
                    confirmData.startTime = moment(item.busDate[0]).format(
                        'YYYY-MM-DD'
                    )
                    confirmData.endTime = moment(item.busDate[1]).format(
                        'YYYY-MM-DD'
                    )
                } else {
                    confirmData.startTime = this.voucherQueryModel.startTime
                    confirmData.endTime = this.voucherQueryModel.endTime
                }
                //处理金额
                confirmData.makeOrderState = item.makeOrderState
                confirmData.groupType = _this.voucherQueryModel.groupType
                _this.queryParam = Object.assign({}, confirmData)
                _this.searchDataTemp = {}
                _this.searchDataTemp = Object.assign({}, confirmData)
            }
        },
        //保存查询方案
        savePlan(item) {
            const _this = this
            if (!item.name) {
                _this.$notify({
                    title: '提示',
                    message: '请输入方案名称',
                    type: 'error',
                    position: 'bottom-right'
                })
                return false
            }
            item.moduleMark = 'Z5SSSF'
            item.brandID = _this.voucherQueryModel.brandId
            var b = _this.checkSearchPlan(item)
            if (b) {
                AjaxHelper.post(
                    _this.VoucherCreateApi + '/SearchPlanCreateOrEdit',
                    item
                )
                    .then(function (response) {
                        if (response.success) {
                            _this.$notify({
                                title: '成功',
                                message: '保存成功',
                                type: 'success',
                                position: 'bottom-right'
                            })
                            _this.initSearchPlan()
                        }
                    })
                    .catch(function (error) {
                        _this.$notify({
                            title: '提示',
                            message: error.message,
                            type: 'error',
                            position: 'bottom-right'
                        })
                    })
            }
        },
        //检查查询方案正确性
        checkSearchPlan(item) {
            const _this = this
            var b = false
            if (item.busDate != null && item.busDate.length == 2) {
                b = true
                item.busDateBegin = moment(item.busDate[0]).format('YYYY-MM-DD')
                item.busDateEnd = moment(item.busDate[1]).format('YYYY-MM-DD')
                if (item.billNo) {
                    b = true
                }
                if (item.otherSideName) {
                    b = true
                }

                if (item.orgName) {
                    b = true
                }

                if (!b) {
                    _this.$notify({
                        title: '提示',
                        message: '请输入查询项',
                        type: 'error',
                        position: 'bottom-right'
                    })
                    return false
                }
                return b
            }
        },

        voucherCreateShow() {
            const _this = this
            _this.openloadingHandler()
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v.sysBillCode)
                    })
                }
            })
            _this.voucherQueryModel.orderIds = _this.selOrderIds
            //凭证生成接口
            const confirmData = {
                brandID: _this.voucherQueryModel.brandId,
                storeCode: _this.voucherQueryModel.shopCode,
                storeID: _this.voucherQueryModel.storeID,
                orderTypeId: _this.voucherQueryModel.orderType,
                startTime: _this.voucherQueryModel.startTime,
                endTime: _this.voucherQueryModel.endTime,
                groupType: _this.voucherQueryModel.groupType,
                orderIds: _this.selOrderIds,
                makeOrderState: _this.voucherQueryModel.makeOrderState,
                isSSSF: true
            }
            AjaxHelper.post(
                _this.VoucherCreateApi + '/MutilShopsZ5CloudDataHandle',
                confirmData
            )
                .then(function (response) {
                    if (response.result.isSuccess) {
                        {
                            _this.$notify({
                                title: '提示',
                                message: response.result.successMsg,
                                type: 'success',
                                position: 'bottom-right'
                            })
                        }
                    } else {
                        _this.$notify({
                            title: '提示',
                            message: response.result.errorMsg,
                            type: 'error',
                            position: 'bottom-right'
                        })
                    }
                    _this.closeloadingHandler()
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        openDialog() {
            const _this = this
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v.sysBillCode)
                    })
                }
            })
            _this.voucherQueryModel.isSSSF = true
            _this.voucherQueryModel.orderIds = _this.selOrderIds
            _this.voucherQueryModel.vouchernumber =
                _this.$refs.refPagerBar.pagerTotal
            if (_this.isMultiOrg) {
                AjaxHelper.get(
                    _this.VoucherCreateApi +
                        '/GetZ5StoreList?brandId=' +
                        _this.voucherQueryModel.brandId +
                        '&isPayOrder=true'
                ).then(function (response) {
                    if (response.success) {
                        if (
                            response.result != null &&
                            response.result.length > 0
                        ) {
                            _this.$refs.targetStore.createDialog(
                                true,
                                response.result,
                                _this.voucherQueryModel,
                                _this.searchDataTemp
                            )
                        } else {
                            _this.$message({
                                type: 'error',
                                position: 'bottom-right',
                                message: '未找到多组织档案对照信息'
                            })
                        }
                    }
                })
            } else {
                _this.voucherCreateShow()
            }
        },
        voucherCreate() {
            if (this.voucherQueryModel.groupType == '') {
                this.$message({
                    type: 'error',
                    message: '请选择凭证生成方式',
                    position: 'bottom-right'
                })
                return false
            }
        },
        getTableData(d) {
            const _this = this
            _this.tableData = d
            //查询无结果 不允许生成凭证
            if (d.length > 0) {
                _this.isSearchVal = true
            } else {
                _this.isSearchVal = false
            }
            if (_this.selOrder.length) {
                _this.selOrder.forEach((item) => {
                    if (item.key == _this.$refs.refPagerBar.currentPage) {
                        _this.toggleSelection(item.value)
                    }
                })
            }
            _this.closeloadingHandler()
        },
        brandChange(val) {
            this.brandSel = true
            this.isSearchVal = false
            var brandInfo = this.brands.filter((x) => x.id == val)[0]
            this.isMultiOrg = brandInfo.isMutilOrg
            this.voucherQueryModel.store = ''
            this.voucherQueryModel.orderType = ''
            this.storesList = this.stores.filter(
                (x) => x.brandID === this.voucherQueryModel.brandId
            )
        },
        statusSearch(item) {
            this.storeSel = false
            this.brandSel = false
            this.CurrnetMID = item.id
            this.voucherQueryModel.brandId = ''
            this.voucherQueryModel.orderType = ''
            this.brandList = this.brands.filter((x) => x.moduleID == item.id)
            this.isSearchVal = false
        },
        getModules() {
            const _this = this
            this.openloadingHandler()
            AjaxHelper.get(
                _this.VoucherCreateApi + '/GetModules?tabType=' + _this.tabType
            )
                .then(function (response) {
                    if (response.success) {
                        _this.moduleList = response.result.modules
                        if (_this.moduleList.length > 0) {
                            const firstItem = _this.moduleList[0]
                            _this.CurrnetMID = firstItem.id
                            _this.brands = response.result.brands
                            _this.stores = response.result.stores
                            // _this.brandList = response.result.brands.filter(
                            //   x => x.moduleID == firstItem.id
                            // );
                            _this.brands.forEach((x) => {
                                _this.moduleList.forEach((element) => {
                                    if (element.id == x.moduleID) {
                                        // x.name = element.name + "/" + x.name;
                                        _this.brandList.push(x)
                                    }
                                })
                            })
                        }
                    }
                    _this.closeloadingHandler()
                })
                .catch(function (error) {
                    _this.closeloadingHandler()
                })
        },
        pickerOptions2() {},
        initData() {},

        handleClose(done) {
            this.isVoucherCreate = false
            done()
        }
    }
}
</script>

<style scoped>
.minicard {
    height: auto !important;
    display: block;
    width: 200px;
    position: absolute;
    right: 0;
    z-index: 9989;
    top: 80px;
}
.minicard .el-button {
    width: 150px;
    margin: 5px 0;
}
.el-dialog__body {
    padding: 10px 15px !important;
}

dl.loglist p {
    font-weight: 600;
    margin: 20px 0 10px 0;
}
dl.loglist dd {
    padding: 15px 0;
    color: #999999;
    display: block;
}
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}
.w25 {
    width: 25%;
    float: left;
}
.w75 {
    width: 75%;
    float: left;
}
.el-card {
    border: 0;
    height: calc(100vh - 225px);
    overflow-y: auto;
}
.padding7 {
    padding: 7px;
}
.top5 {
    padding: 5px 0 0 0;
}
.top7 {
    padding: 7px 0 0 0;
}
</style>
